<!--
 * @Author: Huangxianlong
 * @Date: 2023-05-29 10:27:17
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2026-06-03 15:40:37
 * @FilePath: \monitor\src\view\Main.vue
 * @Description: 
-->

<template>
  <div class="app-wrapper">
    <div class="main-header">
      <div class="header-left">
        <a
          target="_blank"
          href="http://www.sensingtech.com.sg/"
          v-if="$i18n.locale == 'EN'"
        >
          <img src="../assets/SensingtechLogo.jpg" />
        </a>
        <a target="_blank" href="http://www.szjiantai.cn" v-else>
          <img src="../assets/jiantailogo.jpg" />
        </a>
      </div>
      <div class="header-middle-con">
        <Menu
          mode="horizontal"
          theme="light"
          :active-name="activeName"
          @on-select="menuClick"
        >
          <Submenu name="1">
            <template slot="title">
              <Icon type="md-globe" />
              {{ $t("User.Main.projectOverview") }}
            </template>
            <MenuItem name="home">
              <!-- <Icon type="md-globe" /> -->
              {{ $t("User.Main.realTimeOverview") }}
            </MenuItem>
            <MenuItem name="layoutplan">
              <!-- <Icon type="ios-browsers" /> -->
              {{ $t("User.Main.layoutPlan") }}
            </MenuItem>
            <MenuItem name="mark" v-if="$i18n.locale == 'CN'">
              {{ $t("User.Main.mark") }}
            </MenuItem>
          </Submenu>
          <MenuItem name="sensorData">
            <Icon type="md-analytics" />
            {{ $t("User.Main.latestData") }}
          </MenuItem>
          <!-- <MenuItem name="realtimechart">
            <Icon type="ios-stats" />
            {{ $t("User.Main.realtimeChart") }}旧
          </MenuItem> -->
          <MenuItem name="realtime">
            <Icon type="ios-stats" />
            {{ $t("User.Main.realtimeChart") }}
          </MenuItem>
          <!-- <Submenu name="3">
            <template slot="title">
              <Icon type="ios-paper" />
              {{ $t('User.Main.report') }}
            </template>
            <MenuItem name="dailyreport">{{ $t('User.Main.dailtReport') }}</MenuItem>
          </Submenu> -->
          <!-- <MenuItem name="report">
            <Icon type="ios-paper" />
            {{ $t("User.Main.report") }}
          </MenuItem> -->
          <Submenu
            name="3"
          >
            <template slot="title">
              <Icon type="ios-grid" />
              {{ $t("User.Main.reportManagement") }}
            </template>
            <MenuItem name="report">
              <Icon type="ios-paper" />
              {{ $t("User.Main.historicalTrendChart") }}
            </MenuItem>
            <MenuItem name="overview-report" v-if="$i18n.locale == 'CN'">
              <Icon type="md-calculator" />
              {{ $t("User.Main.projectOverviewReport") }}
            </MenuItem>
            <MenuItem name="strainGauge-report">
              <Icon type="md-list-box" />
              {{ $t("User.Main.strainGaugeMonitoringReport") }}
            </MenuItem>
            <MenuItem name="totalStation-report">
              <Icon type="md-calculator" />
              {{ $t("User.Main.totalStationMonitoringReport") }}
            </MenuItem>
            <MenuItem name="vm2030-report" v-if="$i18n.locale == 'CN'">
              <Icon type="ios-paper" />
              {{ $t("User.Main.vm2030MonitoringReport") }}
            </MenuItem>
            <MenuItem name="an1001-report" v-if="$i18n.locale == 'CN'">
              <Icon type="md-calculator" />
              {{ $t("User.Main.an1001MonitoringReport") }}
            </MenuItem>
          </Submenu>
          <MenuItem name="alarm" v-if="loginInfo.userRole == 'common'">
            <Icon type="ios-alarm" />
            {{ $t("User.Main.alarmRecord") }}
          </MenuItem>
          <Submenu
            name="4"
            v-if="
              loginInfo.userRole == 'admin' || loginInfo.userRole == 'project'
            "
          >
            <template slot="title">
              <Icon type="ios-bookmarks" />
              {{ $t("User.Main.projectManagement") }}
            </template>
            <MenuItem name="project" v-if="loginInfo.userRole == 'admin'">{{
              $t("User.Main.projectConfiguration")
            }}</MenuItem>
            <MenuItem
              name="zone"
              v-if="
                loginInfo.userRole == 'admin' || loginInfo.userRole == 'project'
              "
              >{{ $t("User.Main.zoneConfiguration") }}</MenuItem
            >
            <MenuItem
              name="datalogger"
              v-if="
                loginInfo.userRole == 'admin' || loginInfo.userRole == 'project'
              "
              >{{ $t("User.Main.dataloggerConfiguration") }}</MenuItem
            >
            <MenuItem
              name="gzm"
              v-if="
                $i18n.locale == 'CN' && loginInfo.userRole == 'admin'
              "
              >{{ $t("User.Main.gzmConfiguration") }}</MenuItem
            >
          </Submenu>
          <Submenu
            name="5"
            v-if="
              loginInfo.userRole == 'admin' || loginInfo.userRole == 'project'
            "
          >
            <template slot="title">
              <Icon type="md-settings" />
              {{ $t("User.Main.systemManagement") }}
            </template>
            <MenuItem name="user">{{
              $t("User.Main.userManagement")
            }}</MenuItem>
            <MenuItem name="alarm">{{ $t("User.Main.alarmRecord") }}</MenuItem>
          </Submenu>
        </Menu>
      </div>
      <div class="header-avator-con">
        <div class="user-dropdown-menu-project">
          <Row
            type="flex"
            justify="end"
            align="middle"
            class="user-dropdown-innercon"
            style="margin-right: 20px;"
          >
            <Dropdown @on-click="projectEvent">
              <Button type="primary">
                {{ currentprj.projectName }}
                <Icon type="md-arrow-dropdown"></Icon>
              </Button>
              <DropdownMenu slot="list">
                <DropdownItem
                  v-for="item in $store.state.project.projectList.list"
                  :key="item.projectId"
                  :name="item.projectId"
                  :title="item.projectDescription"
                >
                  <Row type="flex" justify="center" align="middle">
                    <span style="margin-right:10px;">{{
                      item.projectName
                    }}</span>
                  </Row>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </Row>
        </div>
        <div class="user-dropdown-menu-con">
          <Row
            type="flex"
            justify="end"
            align="middle"
            class="user-dropdown-innercon"
          >
            <Dropdown transfer trigger="click" @on-click="dropclick">
              <a href="javascript:void(0)">
                <span class="main-user-name">{{ loginInfo.userName }}</span>
                <Icon type="md-arrow-dropdown"></Icon>
              </a>
              <DropdownMenu slot="list">
                <DropdownItem name="person">{{
                  $t("User.Main.userDetail")
                }}</DropdownItem>
                <DropdownItem name="loginout" divided>{{
                  $t("User.Main.logout")
                }}</DropdownItem>
              </DropdownMenu>
              <Avatar
                icon="ios-person"
                style="background: #619fe7; cursor:pointer; font-size: 26px;"
              ></Avatar>
            </Dropdown>
          </Row>
        </div>
      </div>
    </div>
    <!-- 用户添加编辑 -->
    <Modal
      v-model="pesonModel"
      :title="$t('User.Main.userDetail')"
      :mask-closable="false"
      width="650"
    >
      <jtForm
        class="jt-form"
        ref="dataForm"
        :labelWidth="100"
        :columns="columnsHandle('addUserFormColumns')"
        :form.sync="addForm"
        :rules="formRules"
        labelPosition="right"
        colSpan="1"
      ></jtForm>
      <div slot="footer">
        <Button size="large" @click="cancel">{{
          $t("User.Main.cancelBtn")
        }}</Button>
        <Button
          type="primary"
          size="large"
          :loading="addModelLoading"
          @click="saveUserData"
          >{{ $t("User.Main.savelBtn") }}</Button
        >
      </div>
    </Modal>
    <div class="single-page-con">
      <div class="single-page">
        <router-view v-on:setactivename="setActiveName"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { isInstallRules } from "@/libs/util";
import * as api from "@/api";
import Tools from "@/libs/tools";
import { mapActions } from "vuex";
import jtForm from "@/components/jt-from/index.vue";
import { Encrypt, Decrypt } from "@/libs/crypto";
import { clear } from "@/libs/util";

export default {
  components: {
    jtForm
  },
  data() {
    return {
      activeName: "home",
      currentprj: {},
      pesonModel: false,
      formValidate: {
        userId: "",
        userName: "",
        userPassword: "",
        userSex: "",
        userCompany: "",
        userStation: "",
        userMobileTelephone: "",
        userEmail: ""
      },
      userSexList: [
        {
          label: this.$t("Project.User.male"),
          value: "1"
        },
        {
          label: this.$t("Project.User.female"),
          value: "2"
        }
      ],
      userRoleList: [
        {
          label: this.$t("Project.User.systemAdmin"),
          value: "admin"
        },
        {
          label: this.$t("Project.User.projectAdmin"),
          value: "project"
        },
        {
          label: this.$t("Project.User.ordinaryUsers"),
          value: "common"
        }
      ],
      addUserFormColumns: [
        {
          type: "input",
          title: this.$t("Project.User.userId"),
          value: "userId",
          maxlength: 20,
          disabled: false,
          showWordLimit: true,
          placeholder: this.$t("Project.User.userIdPla"),
          rules: [
            {
              required: true,
              message: this.$t("Project.User.userIdRules")
            }
          ]
        },
        {
          type: "input",
          title: this.$t("Project.User.userName"),
          value: "userName",
          maxlength: 20,
          disabled: true,
          showWordLimit: true,
          placeholder: this.$t("Project.User.userNamePla"),
          rules: [
            {
              required: true,
              message: this.$t("Project.User.userNameRules")
            }
          ]
        },
        {
          type: "select",
          title: this.$t("Project.User.gender"),
          value: "userSex",
          placeholder: this.$t("Project.User.genderPla"),
          openKey: "value",
          showKey: "label",
          openList: "userSexList",
          rules: [
            {
              required: true,
              message: this.$t("Project.User.genderRules")
            }
          ]
        },
        {
          type: "input",
          title: this.$t("Project.User.password"),
          value: "userPassword",
          inputType: "password",
          maxlength: 20,
          // showWordLimit: true,
          placeholder: this.$t("Project.User.passwordPla"),
          rules: [
            {
              required: true,
              message: this.$t("Project.User.passwordRules")
            }
          ]
        },
        {
          type: "select",
          title: this.$t("Project.User.role"),
          value: "userRole",
          disabled: true,
          placeholder: this.$t("Project.User.rolePla"),
          openKey: "value",
          showKey: "label",
          openList: "userRoleList",
          rules: [
            {
              required: true,
              message: this.$t("Project.User.roleRules")
            }
          ]
        },
        {
          type: "input",
          title: this.$t("Project.User.unit"),
          value: "userCompany",
          maxlength: 20,
          showWordLimit: true,
          placeholder: this.$t("Project.User.unitPla"),
          rules: [
            {
              required: true,
              message: this.$t("Project.User.unitRules")
            }
          ]
        },
        {
          type: "input",
          title: this.$t("Project.User.duties"),
          value: "userStation",
          maxlength: 20,
          showWordLimit: true,
          placeholder: this.$t("Project.User.dutiesPla"),
          rules: [
            {
              required: true,
              message: this.$t("Project.User.dutiesRules")
            }
          ]
        },
        {
          type: "input",
          title: this.$t("Project.User.email"),
          value: "userEmail",
          maxlength: 20,
          showWordLimit: true,
          placeholder: this.$t("Project.User.emailPla"),
          rules: [
            {
              required: true,
              message: this.$t("Project.User.emailRules")
            }
          ]
        },
        {
          type: "input",
          title: this.$t("Project.User.phone"),
          value: "userMobileTelephone",
          maxlength: 11,
          showWordLimit: true,
          placeholder: this.$t("Project.User.phonePla"),
          rules: [
            {
              required: true,
              message: this.$t("Project.User.phoneRules")
            }
          ]
        }
      ],
      addModelLoading: false,
      addForm: {},
      projectList: [],
      firstTime: true
    };
  },
  watch: {
    $route: {
      handler(val, oldVal) {
        this.$nextTick(() => {
          this.activeName = val.name;
          // if (val.name == "home") {
          //   this.getProjectListAction();
          // }
        });
      },
      deep: true,
      immediate: true
    },
    "$store.state.project.projectList.list": {
      handler(newList, oldList) {
        if (
          newList.filter(
            item =>
              item.projectId == Tools.methods.StorageGet("currentprj").projectId
          ).length == 0
        ) {
          this.projectEvent(newList[0].projectId);
        }
      },
      deep: true
    }
  },
  created() {
    sessionStorage.setItem("languageSet", serverConfig.language);
    try {
      this.currentprj = Tools.methods.StorageGet("currentprj");
      // this.setTreeData(this.currentprj.projectId);
    } catch (error) {
      this.$router.push({
        path: "/login"
      });
    }
    this.getProjectListAction();
  },
  mounted() {
    this.projectList = Tools.methods.StorageGet("projectList");
    // this.$store.commit("setProjectIdMutation", this.currentprj.projectId);
  },
  computed: {
    loginInfo() {
      this.formValidate = Tools.methods.StorageGet("loginInfo");
      return Tools.methods.StorageGet("loginInfo");
    },
    avatorPath() {
      return sessionStorage.avatorImgPath;
    },
    getProjectInfos() {
      if (
        Tools.methods.StorageGet("loginInfo") &&
        Tools.methods.StorageGet("loginInfo").projectInfos
      ) {
        if (!this.currentprj)
          this.currentprj = Tools.methods.StorageGet(
            "loginInfo"
          ).projectInfos[0];
        return Tools.methods.StorageGet("loginInfo").projectInfos;
      } else {
        return [];
      }
    },
    formRules() {
      return isInstallRules(this.addUserFormColumns);
    }
  },
  methods: {
    ...mapActions(["setTreeData", "getProjectListAction"]),
    // FROM表单openList的处理方法
    columnsHandle(columnsName) {
      return this[columnsName].map(item => ({
        ...item,
        openList: item.openList && [
          ...(typeof item.openList === "string"
            ? [...this[item.openList]]
            : item.openList)
        ]
      }));
    },
    setActiveName(val) {
      this.activeName = val;
    },
    setCurrentProject(prj) {
      this.currentprj = prj;
    },
    cancel() {
      this.pesonModel = false;
      this.$refs.dataForm.isResetFields();
      this.addForm = {};
    },
    // 保存用户信息
    async saveUserData() {
      const valid = await this.$refs.dataForm.isCheck();
      if (valid) {
        this.addModelLoading = true;
        this.addForm.userPassword = this.addForm.userPassword;
        this.addForm.password = Encrypt(this.addForm.userPassword);
        api.saveUserInfo(this.addForm).then(res => {
          if (res.body.code == "0") {
            this.pesonModel = false;
            this.$Message.success(this.$t("User.Main.userFormSuccess"));
          } else {
            this.$Message.error(res.body.msg);
          }
          this.addModelLoading = false;
          this.$refs.dataForm.isResetFields();
        });
      } else {
        this.$Message.warning(this.$t("User.Main.userFormWarn"));
      }
    },
    projectEvent(data) {
      // console.log(data);
      // console.log(this.$store);
      this.$store.commit("setProjectIdMutation", data);
      // console.log(this.$store.state.project.projectId);
      var _that = this;
      var projects = this.$store.state.project.projectList.list;
      projects.forEach(function(val, index) {
        if (data === val.projectId) {
          _that.currentprj = val;
          Tools.methods.StorageSet({
            key: "currentprj",
            val: val
          });
          var currentpage = Tools.methods.StorageGet("currentpage");
          // _that.setTreeData(_that.currentprj.projectId);
          // if (currentpage == "home") {
          //   _that.getDataloggerInfoByPrjIdAction(_that.currentprj.projectId);
          //   //根据项目编号获取所有传感器信息
          //   _that.getSensorinfoByPrjIdAction(_that.currentprj.projectId);
          // }
          if (currentpage) {
            if (currentpage == "home") {
              _that.$router.push({
                name: currentpage,
                query: { projectId: val.projectId }
              });
            }
          }
        }
      });
    },
    logOut() {
      clear();
      this.$router.push({
        name: "login"
      });
      this.$nextTick(() => {
        var storage = window.sessionStorage;
        storage.clear();
      });
    },
    dropclick(value) {
      if (value === "person") {
        this.pesonModel = true;
        const list = this.addUserFormColumns.map(item => {
          if (item.value == "userId") {
            item.disabled = true;
          }
          return item.value;
        });
        for (let i of list) {
          this.$set(this.addForm, i, this.formValidate[i]);
          // if (i == "userPassword") {
          //   this.$set(this.addForm, i, Decrypt(this.formValidate[i]));
          // } else {
          // }
        }
        this.$set(this.addForm, "status", this.formValidate["status"]);
      } else {
        this.logOut();
      }
    },
    menuClick(value) {
      this.$router.push({
        name: value
      });
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    }
  }
};
</script>
<style lang="less" scoped>
@import "./main.less";

/* A1: 全屏高度约束，消除内容高度不足时底部空白 */
.app-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f0f0f0;
}

.app-wrapper ::v-deep .single-page-con {
  position: static;
  flex: 1;
  display: flex;
  flex-direction: column;
  top: auto;
  right: auto;
  bottom: auto;
  background-color: transparent;
  z-index: auto;
  transition: none;
  min-height: calc(100vh - 100px);
}

.app-wrapper ::v-deep .single-page {
  margin: 10px;
  flex: 1;
  min-height: calc(100vh - 120px);
}

.main-header {
  /deep/.ivu-menu-horizontal.ivu-menu-light:after {
    height: 0;
  }

  .header-left {
    height: 100%;
    display: flex;
    align-items: center;
    padding-left: 8px;

    a {
      display: inherit;
    }
  }
  user-select: none;
}
// /deep/.user-dropdown-menu-con{

/deep/.ivu-dropdown .ivu-select-dropdown {
  max-height: 800px !important;
  overflow: auto !important;
}
// }
</style>



// WEBPACK FOOTER //
// src/view/Main.vue